import { useContext } from 'react';
import { EditProfileContext } from './edit-profile-context-definition';

export const useEditProfileModal = () => {
  const context = useContext(EditProfileContext);
  if (!context) {
    throw new Error('useEditProfileModal must be used within an EditProfileProvider');
  }
  return context;
};
